// S2-FE2: Badge
import './Badge.css';

export interface BadgeProps {
  variant: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'primary' | 'signal';
  size?: 'sm' | 'md';
  children: React.ReactNode;
}

export function Badge({ variant, size = 'md', children }: BadgeProps) {
  return (
    <span className={`airgent-badge airgent-badge-${variant} airgent-badge-${size}`}>
      {children}
    </span>
  );
}
